import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Alert } from "react-bootstrap";
import { API_BASE } from "../../lib/apiBase";

/**
 * EnquiryForm
 * Reusable lightweight enquiry form (name, email, message).
 *
 * Props:
 * - endpoint: string (default `${API_BASE}/enrolments`) — where to POST
 * - buttonLabel: string (default "Submit")
 * - compact: boolean (default true) — style-neutral; parent can style
 *
 * This component contains only the form UI + submit logic.
 */
const EnquiryForm = ({
  endpoint = `${API_BASE}/enrolments`,
  buttonLabel = "Submit",
  compact = true,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      setSubmitting(true);
      await axios.post(
        endpoint,
        { name, email, message },
        { withCredentials: true }
      );
      setSubmitted(true);
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      console.error("❌ Enquiry submit failed:", err);
      setErrorMsg("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} noValidate className={compact ? "" : "p-3"}>
      <Form.Group className="mb-3">
        <Form.Label className="mb-1" style={{ color: "#2b333d" }}>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter your name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="mb-1" style={{ color: "#2b333d" }}>Email</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter your email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="mb-1" style={{ color: "#2b333d" }}>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Your message or inquiry"
          required
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Form.Group>

      <Button
        type="submit"
        variant="primary"
        className="w-100 fw-semibold text-uppercase"
        disabled={submitting}
      >
        {submitting ? "Sending…" : buttonLabel}
      </Button>

      {submitted && (
        <Alert variant="success" className="mt-3 text-center">
          Thank you! Your message has been sent.
        </Alert>
      )}
      {errorMsg && (
        <Alert variant="danger" className="mt-3 text-center">
          {errorMsg}
        </Alert>
      )}
    </Form>
  );
};

export default EnquiryForm;
